import { useCallback } from 'react';

import { FieldsEnum } from 'app/shared/enums';
import { DateControlCommitApi } from 'app/components/Controls/DateControl/DateControl.interfaces';
import {
  TravelDateRangeRole,
  useTravelDateRangeContext,
} from 'app/components/TravelInsurancePeriodSection/TravelDateRange.context';
import { TravelDateRangeControlProps } from './TravelDateRangeControl.interfaces';

const rolesByQuestionKey: { [key: string]: TravelDateRangeRole } = {
  [FieldsEnum.TravelStartDate]: 'start',
  [FieldsEnum.TravelEndDate]: 'end',
};

export function useTravelDateRangeControl({
  questionKey,
  minDate,
  maxDate,
}: TravelDateRangeControlProps) {
  const rangeContext = useTravelDateRangeContext();
  const role = rolesByQuestionKey[questionKey];

  const isRangeField = Boolean(rangeContext) && Boolean(role);
  const registerField = rangeContext?.registerField;
  const openRange = rangeContext?.openRange;

  const handleRegisterCommit = useCallback(
    (api: DateControlCommitApi) => {
      if (!registerField || !role) {
        return;
      }

      registerField(role, {
        ...api,
        minDate: api.resolvedMinDate || minDate,
        maxDate,
      });
    },
    [registerField, role, minDate, maxDate]
  );

  const handleRequestOpen = useCallback(() => {
    if (openRange && role) {
      openRange(role);
    }
  }, [openRange, role]);

  return {
    isRangeField,
    isRangeDialogOpen: Boolean(rangeContext?.isRangeDialogOpen),
    handleRegisterCommit,
    handleRequestOpen,
  };
}
